import icons from '@icons';

const {
  vkontakte: { red: vkontakteRed, ultraDG: vkontakteUltraDG },
  telegram: { red: telegramRed, ultraDG: telegramUltraDG },
  max: { red: maxRed, ultraDG: maxUltraDG },
  dzen: { red: dzenRed, ultraDG: dzenUltraDG },
  vkVideo: { red: vkVideoRed, ultraDG: vkVideoUltraDG },
  youtube: { red: youtubeRed, ultraDG: youtubeUltraDG },
  tiktok: { red: tiktokRed, ultraDG: tiktokUltraDG },
  rutube: { red: rutubeRed, ultraDG: rutubeUltraDG },
  ok: { red: okRed, ultraDG: okUltraDG }
  // facebook: { grey: facebookGrey, red: facebookRed },
  // instagram: { grey: instagramGrey, red: instagramRed },
} = icons.Fill;

export const socialIcons = {
  vkontakte: {
    alt: 'vkontakte',
    src: vkontakteUltraDG,
    srcDark: vkontakteUltraDG,
    srcHover: vkontakteRed,
    href: 'https://vk.com/delikateska'
  },
  telegram: {
    alt: 'telegram',
    src: telegramUltraDG,
    srcDark: telegramUltraDG,
    srcHover: telegramRed,
    href: 'https://t.me/delikateska_ru'
  },
  max: {
    alt: 'max',
    src: maxUltraDG,
    srcDark: maxUltraDG,
    srcHover: maxRed,
    href: 'https://max.ru/u/f9LHodD0cOI21e7qWyewBTxCZgCyh-vaYLDfMxCCskt-5txgeSWwl1sWiD0'
  },
  dzen: {
    alt: 'dzen',
    src: dzenUltraDG,
    srcDark: dzenUltraDG,
    srcHover: dzenRed,
    href: 'https://zen.yandex.ru/delikateska'
  },
  vkVideo: {
    alt: 'Vk Video',
    src: vkVideoUltraDG,
    srcDark: vkVideoUltraDG,
    srcHover: vkVideoRed,
    href: 'https://vkvideo.ru/@delikateska'
  },
  youtube: {
    alt: 'youtube',
    src: youtubeUltraDG,
    srcDark: youtubeUltraDG,
    srcHover: youtubeRed,
    href: 'https://www.youtube.com/channel/UCFvD0U9TlJtZ-cdgVjLYmCQ'
  },
  tiktok: {
    alt: 'tiktok',
    src: tiktokUltraDG,
    srcDark: tiktokUltraDG,
    srcHover: tiktokRed,
    href: 'https://www.tiktok.com/@delikateska.ru'
  },
  rutube: {
    alt: 'rutube',
    src: rutubeUltraDG,
    srcDark: rutubeUltraDG,
    srcHover: rutubeRed,
    href: 'https://rutube.ru/channel/23890568/'
  },
  ok: {
    alt: 'ok',
    src: okUltraDG,
    srcDark: okUltraDG,
    srcHover: okRed,
    href: 'https://ok.ru/delikateska'
  }
  // facebook: { alt: 'facebook', src: facebookGrey, srcHover: facebookRed, href: 'https://www.facebook.com/delikateska' },
  // instagram: { alt: 'instagram', src: instagramGrey, srcHover: instagramRed, href: 'https://www.instagram.com/delikateska.ru/' },
};

export const socialIconsArr = Object.values(socialIcons);
